import React from 'react';

/**
 * Die Varianten nutzen ausschliesslich die Design-Token aus src/index.css.
 *
 * Vorher standen hier Klassen wie `bg-primary-600` und `bg-energy-green` —
 * dafuer existiert im Projekt KEINE Farbskala, Tailwind erzeugte also gar keine
 * Regel. Ein primaerer Button war damit weisse Schrift auf durchsichtigem
 * Grund, also praktisch unsichtbar. Die Token-Variante funktioniert zugleich
 * im Dark Mode (InternalLayout schaltet .dark auf dem <html>-Element).
 */
const variants = {
  primary: 'bg-primary text-primary-foreground hover:bg-primary/90 focus:ring-primary',
  secondary: 'bg-card text-card-foreground border border-border hover:bg-muted/40 focus:ring-primary',
  danger: 'bg-destructive text-white hover:bg-destructive/90 focus:ring-destructive',
  success: 'bg-success text-white hover:bg-success/90 focus:ring-success',
  ghost: 'text-muted-foreground hover:bg-muted/40 hover:text-foreground focus:ring-primary',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconRight: IconRight,
  disabled = false,
  loading = false,
  className = '',
  ...props
}) => {
  return (
    <button
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center font-medium rounded-lg
        transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      ) : Icon ? (
        <Icon className="mr-2 -ml-0.5" size={16} />
      ) : null}
      {children}
      {IconRight && <IconRight className="ml-2 -mr-0.5" size={16} />}
    </button>
  );
};

export default Button;
